
// Simple image validation utilities
export const isValidImageDataUrl = (dataUrl: string): boolean => {
  if (!dataUrl || typeof dataUrl !== 'string') {
    console.log('🖼️ imageValidation: Invalid - not a string or empty');
    return false;
  }
  
  // Must start with data:image/
  if (!dataUrl.startsWith('data:image/')) {
    console.log('🖼️ imageValidation: Invalid - does not start with data:image/');
    return false;
  }
  
  // Must contain base64 marker
  if (!dataUrl.includes(';base64,')) {
    console.log('🖼️ imageValidation: Invalid - no base64 marker');
    return false;
  }
  
  // Extract base64 part and check basic length
  const base64Part = dataUrl.split(';base64,')[1];
  if (!base64Part || base64Part.length < 100) {
    console.log('🖼️ imageValidation: Invalid - base64 data too short or missing');
    return false;
  }
  
  console.log('🖼️ imageValidation: Valid image data URL');
  return true;
};

export const isImageUrl = (url: string): boolean => {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
  const urlLower = url.toLowerCase();
  return imageExtensions.some(ext => urlLower.includes(ext)) || 
         url.includes('unsplash.com') || 
         url.includes('picsum.photos') ||
         url.includes('images.') ||
         urlLower.includes('image');
};

export const isImageTargetUrl = (url: string): boolean => {
  if (!url) return false;
  
  const urlLower = url.toLowerCase();
  
  // Check for common image hosting services
  const imageServices = [
    'picsum.photos',
    'unsplash.com',
    'images.unsplash.com',
    'source.unsplash.com',
    'via.placeholder.com',
    'placehold.it',
    'lorempixel.com',
    'dummyimage.com',
    'fakeimg.pl'
  ];
  
  // Check if URL contains image service domains
  if (imageServices.some(service => urlLower.includes(service))) {
    return true;
  }
  
  // Check for direct image file extensions
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
  return imageExtensions.some(ext => urlLower.includes(ext));
};
